import React from 'react';
import { useGetTasksQuery } from 'redux/apiSlice/pillarsActionPlan.slice';
import { TTask } from 'data/types/pillarsActionPlan.types';

interface UseTaskAssigneeFiltersProps {
  actionPlanId: number;
  tempTasks?: TTask[];
}

export const useTaskAssigneeFilters = ({
  actionPlanId,
  tempTasks = [],
}: UseTaskAssigneeFiltersProps) => {
  const { data: allTasksData } = useGetTasksQuery({
    page: 0,
    pageSize: 2000,
    sortColumn: { sortDirection: undefined, sortField: undefined },
    filters: undefined,
    actionPlanId,
  });

  const assigneeFilters = React.useMemo(() => {
    const apiTasks = allTasksData?.content || [];
    const combinedTasks = [...tempTasks, ...apiTasks];

    if (!combinedTasks.length) return [];

    const uniqueAssignees = Array.from(
      new Set(
        combinedTasks
          .map(task => task.assignee)
          .filter(
            (assignee): assignee is string =>
              assignee != null && assignee.trim() !== '',
          ),
      ),
    );

    return uniqueAssignees.map(assignee => ({
      text: assignee,
      value: assignee,
    }));
  }, [allTasksData?.content, tempTasks]);

  return assigneeFilters;
};
